import React, { Component } from 'react'
import ScreenRenderer from '@rwitl/screen-renderer/lib/ScreenRenderer/StatelessScreenRenderer'
import { shimMissingComponentTypes } from './componentMap'
import PagesRenderer from './PagesRenderer'
import addPageToScreenState from './addPageToScreenState'
import SideControl from './SideControl'
import extractFields from '@rwitl/reformed-util/lib/extractFields'
import ReactDOM from 'react-dom'
import DraggingFieldsScreenRenderer from './DraggingFieldsScreenRenderer'
import { getAllSelectedCheckboxes } from './../editorReducer/selectionCheckboxes'
import { getBlockParent} from './FieldsRenderer/FieldsRenderer'
import injectStyles from 'react-jss'
import Button from './../../../Button'

const styles = {
  draggingContainer: {
    position: 'absolute',
    pointerEvents: 'none',
    opacity: 0.9,
  },
  footerBar: {
    height: 90,
    backgroundColor: 'white',
    borderTop: '1px solid #f9fafa',
    lineHeight: '90px',
    paddingLeft: 130,
    paddingRight: 130,
  },
  addPageButton: {
    height: 55,
    width: 358,
    opacity: 0.5,
    transition: 'opacity 0.2s',
    '&:hover': {
      opacity: 1,
    },
  },
}

class CustomScreenRenderer extends Component {

  constructor(props){
    super(props)

    this.extraFieldProps = {
      askUserToDelete: this.askUserToDelete,
      onDragStart: this.onDragStart,
    }

    this.screenState_ = props.screenState
  }


  componentWillReceiveProps = (newProps) => {
  if (this.props.screenState != newProps.screenState){

      if (this.dragging_){
        // If we're dragging we need to merge the changes into
        // two sub screen states
        /*var draggingScreenState = JSON.parse(JSON.stringify(this.draggingScreenState_))
        var screenState = JSON.parse(JSON.stringify(this.screenState_))
        Object.entries(newProps.screenState).forEach(([key, field]) => {
          if (key == 'layout'){
            // Ignore for now
            return
          }
          var fieldClone = Object.assign({}, field)
          // Remove anything that isn't a primitive as we only care about
          // merging in primitive props at the moment
          Object.keys(fieldClone).forEach(key => {
            if (typeof fieldClone[key] === 'object')
              delete fieldClone[key]
          })
          if (draggingScreenState[key]){
            draggingScreenState[key] = Object.assign({}, draggingScreenState[key], fieldClone)
          } else if (screenState[key]){
            screenState[key] = Object.assign({}, screenState[key], fieldClone)
          } else {
            // TODO New field, we haven't got anything to handle this case
            // Why not write it
          }
        })
        this.draggingScreenState_ = draggingScreenState
        this.screenState_ = screenState
        this.forceUpdate()*/
      } else {
        this.screenState_ = newProps.screenState
        this.forceUpdate()
      }
    }
  }

  componentDidMount = () => {
    document.body.addEventListener('mouseup', this.onMouseUp)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('mouseup', this.onMouseUp)
  }


  /**
   * Fired when a control asks the user if it wants to delete it
   * @param {object} obj Expects an 'event' property, uses this to determine
   * what to do, if it was a touch down or mouse down event it will display
   * a drag to bucket UI.
   * @returns {Promise<boolean>} Returns true on successful deletion else false
   */
  askUserToDelete = (obj) => {
    debugger
  };

  onDragStart = (e, fieldKeys) => {
    this.startDragPos_ = { pageX: e.pageX, pageY: e.pageY }
    var { screenState, nestedLayout } = this.props
    if (nestedLayout.length > 0)
      throw new Error(`Child screen drag not yet supported, please write it.`)

    // Figure out if multiple fields are selected
    // Modify the screenState to also make the fieldKeys selected so that
    // when we pull them out from the below method they are in the correct order
    var screenStateCopy = JSON.parse(JSON.stringify(screenState))
    fieldKeys.forEach(key => {
      screenStateCopy[key] = Object.assign({}, screenStateCopy[key])
      screenStateCopy[key]['checkboxSelected'] = true
    })
    var selectedFields = getAllSelectedCheckboxes(screenStateCopy)

    var { screenState, subScreenState } = extractFieldsIntoSubState(selectedFields, screenState)
    this.screenState_ = screenState
    this.dragging_ = true
    this.draggingScreenState_ = subScreenState
    this.forceUpdate()

    // Find the position the mouse is relative to the block
    this.relativeDragPosToBlock_ = getRelativeDragPostToBlock(e)


      /*var testDiv = document.createElement('div')
      document.body.appendChild(testDiv)
      testDiv.style.position = 'absolute'
      testDiv.style.border = '1px solid red'
      testDiv.style.height = '3px'
      testDiv.style.width = '3px'
      testDiv.style.left = e.pageX - this.relativeDragPosToBlock_.left + 'px'
      testDiv.style.top = e.pageY - this.relativeDragPosToBlock_.top + 'px'
      debugger*/
    document.body.addEventListener('mousemove', this.repositionDragger)

  };

  onDrop = (success, nextSibling, parentKey) => {

    document.body.removeEventListener('mousemove', this.repositionDragger)

    if (!success){
      this.dragging_ = false
      this.draggingScreenState_ = null
      this.screenState_ = this.props.screenState
      this.forceUpdate()
      return
    }

    var draggingScreenState = this.draggingScreenState_
    var screenState = this.screenState_

    this.dragging_ = false
    this.draggingScreenState_ = null


    screenState = JSON.parse(JSON.stringify(screenState))
    screenState[parentKey] = Object.assign({}, screenState[parentKey])
    var layout = screenState[parentKey].layout.slice(0)
    var index = layout.indexOf(nextSibling)
    if (index == -1) index = layout.length
    draggingScreenState.layout.reverse().forEach(key => {
      layout.splice(index, 0, key)
      screenState[key] = draggingScreenState[key]
    })
    screenState[parentKey].layout = layout
    screenState = removeFieldSelections(screenState)
    this.onScreenStateChange(screenState)
  }

  repositionDragger = (e) => {
    if (e.preventDefault) // Intially this isn't actually an event
      e.preventDefault() // Stop the page being selected
    if (this.draggingContainer_){
      this.draggingContainer_.style.top = e.pageY - this.relativeDragPosToBlock_.top + 'px'
      this.draggingContainer_.style.left = e.pageX - this.relativeDragPosToBlock_.left + 'px'
    }
  }

  onAddPage = () => {
    var { nestedLayout, screenState } = this.props
    var newScreenState = addPageToScreenState(screenState, nestedLayout)
    this.onScreenStateChange(newScreenState)
  }

  onScreenStateChange = (screenState) => {
    this.screenState_ = screenState
    this.forceUpdate()
    this.props.onScreenStateChange(screenState)
  }

  render = () => {

    const {
      nestedLayout,
      renderedPages,
      onControlUpdate,
      onChildScreenLoad,
      onPageChange,
      getScreenState,
      classes,
      flatSchema,
    } = this.props

    var componentMap = shimMissingComponentTypes(getFieldTypes(flatSchema))

    return <div>
      <ScreenRenderer
        extraFieldProps={this.extraFieldProps}
        componentMap={componentMap}
        PagesRenderer={PagesRenderer}
        nestedLayout={nestedLayout}
        renderedPages={renderedPages}
        screenState={this.screenState_}
        onControlUpdate={onControlUpdate}
        onChildScreenLoad={onChildScreenLoad}
        onPageChange={onPageChange}
        readOnly={false}
        onStateChange={this.onScreenStateChange}
        getScreenState={getScreenState}
        SideControl={SideControl}
        dragging={this.dragging_}
        onDrop={this.onDrop}
      />
      {this.draggingScreenState_ ? ReactDOM.createPortal(
        <div className={classes.draggingContainer} ref={el => {
          this.draggingContainer_ = el
          if (this.draggingContainer_)
            this.repositionDragger(this.startDragPos_)
        }}>
          <DraggingFieldsScreenRenderer
            screenState={this.draggingScreenState_}
            flatSchema={flatSchema}
          />
        </div>,
        document.body,
      ) : null}
      <div className={classes.footerBar}>
        <Button
          onClick={this.onAddPage}
          className={classes.addPageButton}
        >
          Add Page
        </Button>
      </div>
    </div>
  }
}

export default injectStyles(styles)(CustomScreenRenderer)


/**
 * Pulls out the field keys into their own flat schema and returns
 * both the new schema and the old schema without the keys
 * @param {Array<string>} fieldKeys
 * @param {object} screenState
 * @returns {object} Props 'screenState' and 'subScreenState'
 */
function extractFieldsIntoSubState(fieldKeys, screenState){
  var { screenState, fields } = extractFields(fieldKeys, screenState)

  var subScreenState = Object.assign({}, fields, {
    layout: fieldKeys.slice(0),
  })

  return {
    screenState,
    subScreenState,
  }
}

/**
 * Gets the top, left position the mouse is relative to the current target
 * block.
 * @param {MouseEvent}
 * @returns {object} With props 'top' and 'left'
 */
function getRelativeDragPostToBlock(e){
  var { block } = getBlockParent(e.target)

  var bounds = getPageBounds(block)

  var relBounds = {
    left: e.pageX - bounds.left,
    top: e.pageY - bounds.top
  }
  return relBounds
}

/**
 * Returns the elements position relative to the page
 * @param {Element} el
 * @return {object} With props 'top' and 'left'
 */
function getPageBounds(el){
  var viewportBounds = el.getBoundingClientRect()
  return {
    top: viewportBounds.top + window.scrollY,
    left: viewportBounds.left + window.scrollX,
  }
}

/**
 * Gets all the field types in use on a flat schema.
 * @param {object} flatSchema
 * @returns {Array<string>}
 */
export function getFieldTypes(flatSchema){
  var fieldTypes = []
  Object.entries(flatSchema).forEach(([ key, field ]) => {
    if (key == 'layout') return
    const { type } = field
    if (type == 'form' || type == 'page') return
    if (fieldTypes.includes(type)) return
    fieldTypes.push(type)
  })
  return fieldTypes
}


/**
 * Removes all the field selections from screenState
 * @param {object} screenState
 * @returns {object}
 */
function removeFieldSelections(screenState){
  var newScreenState = Object.assign({}, screenState), changed = false
  Object.entries(screenState).forEach(([key, field]) => {
    if (key == 'layout') return
    if (field.type == 'page' || field.type == 'form') return

    var fieldClone = Object.assign({}, field)
    newScreenState[key] = fieldClone
    ;['showCheckbox', 'checkboxSelected', 'selected'].forEach(pruneKey => {
      if (field[pruneKey]){
        delete fieldClone[pruneKey]
        changed = true
      }
    })
  })
  return changed ? newScreenState : screenState
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/ScreenRenderer.js